export default "__VITE_ASSET__a1784cec__"